var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-tree',{staticClass:"draggable-tree",attrs:{"default-expanded-keys":_vm.expandedKeys,"draggable":"","tree-data":_vm.gData},on:{"dragenter":_vm.onDragEnter,"drop":_vm.onDrop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }